import React, { useState, useEffect } from "react";
import "./SubVendor.css";
import AddSubVendor from "./AddSubVendor";
import config from "../../config";
import { GrAddCircle } from "react-icons/gr";
import { BsSliders } from "react-icons/bs";
import { IoSearchOutline } from "react-icons/io5";
import Header from "../../components/common/Header";


const SubVendor = ({ setActivePage }) => {
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
    orgId: "",
  });

  const [subVendors, setSubVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [showAddSubVendor, setShowAddSubVendor] = useState(false);
  const [selectedSubVendor, setSelectedSubVendor] = useState(null); // for view mode
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({
    subVendorType: "",
    subVendorCategory: "",
    status: "",
    location: "",
    sortBy: "",
  });
  // Function to fetch data with filter params
  const fetchSubVendors = async (appliedFilters = {}) => {
    setLoading(true);
    try {
      // Constructing query parameters
      const queryParams = new URLSearchParams({
        orgKey: userDetails.orgId,
        page: 0, // Backend logic-kku etrapol maattralaam
        size: 1000, // Fetch all; paging is done on the client
        search: searchTerm,
        location: appliedFilters.location || "",
        subVendorCategory: appliedFilters.subVendorCategory || "",
        subVendorType: appliedFilters.subVendorType || "",
        status: appliedFilters.status || "",
        // Sort logic
        sortBy: appliedFilters.sortBy === "name-asc" || appliedFilters.sortBy === "name-desc" ? "subVendorName" : "",
        sortOrder: appliedFilters.sortBy === "name-desc" ? "DESC" : "ASC"
      });

      const url = `${config.API_BASE_URL}${config.SUBVENDOR_LIST_ENDPOINT}?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        }
      });

      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      const normalized = Array.isArray(data.body) ? data.body.map(vendor => ({
        subVendorId: vendor.subVendorId || vendor.id || null,
        subVendorName: vendor.subVendorName || "-",
        subVendorCategory: vendor.subVendorCategory || "-",
        phoneNumber: vendor.phoneNumber || "-",
        subVendorEmail: vendor.subVendorEmail || "-",
        subVendorType: vendor.subVendorType || "-",
        status: vendor.status || "Active",
        address: vendor.address || "-",
        city: vendor.city || "-",
      })) : [];

      setSubVendors(normalized);
      setError(null);
    } catch (err) {
      setError("Could not load sub vendors.");
      setSubVendors([]);
    } finally {
      setLoading(false);
    }
  };


  // ... existing state
  const [vendorTypes, setVendorTypes] = useState([]); // New state for types
  const [vendorCategories, setVendorCategories] = useState([]);

  useEffect(() => {
    if (!showFilter || !userDetails.orgId || !userDetails.token) return;

    const fetchDropdownData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        };

        const [typeRes, catRes] = await Promise.all([
          fetch(`${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${userDetails.orgId}?configType=SubVendorType`, { headers }),
          fetch(`${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${userDetails.orgId}?configType=SubVendorCategory`, { headers })
        ]);

        const typeData = await typeRes.json();
        const catData = await catRes.json();


        const finalTypes = Array.isArray(typeData) ? typeData : typeData.body || [];
        const finalCats = Array.isArray(catData) ? catData : catData.body || [];

        setVendorTypes(finalTypes);
        setVendorCategories(finalCats);

        console.log("Types Loaded:", finalTypes); // Check in console
      } catch (err) {
        console.error("Error fetching filter options:", err);
      }
    };

    fetchDropdownData();
  }, [showFilter, userDetails.orgId, userDetails.token]);

  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    const orgId = localStorage.getItem("orgId") || "";

    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId,
    });
  }, []);

  useEffect(() => {
    if (!userDetails.token) return;




    const fetchSubVendors = async () => {
      setLoading(true);
      try {
        // Use orgKey as query param
        const url = `${config.API_BASE_URL}${config.SUBVENDOR_LIST_ENDPOINT}?orgKey=${userDetails.orgId}&page=0&size=1000`;
        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch sub vendors");
        }

        const data = await response.json();
        const normalized = Array.isArray(data.body)
          ? data.body.map((vendor) => ({
            subVendorId: vendor.subVendorId || vendor.id || null,
            subVendorName: vendor.subVendorName || vendor.name || "-",
            subVendorCategory: vendor.subVendorCategory || vendor.category || "-",
            phoneNumber: vendor.phoneNumber || vendor.phone || "-",
            subVendorEmail: vendor.subVendorEmail || "-",
            subVendorType: vendor.subVendorType || vendor.type || "-",
            status: vendor.status || "Active",
            address: vendor.address || "-",
            city: vendor.city || "-",
          }))
          : [];

        setSubVendors(normalized);
        setError(null);
      } catch (err) {
        console.error("SubVendor fetch error:", err);
        setError("Could not load sub vendors.");
        setSubVendors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubVendors();
  }, [userDetails.token]);

  const handleAddSubVendor = () => {
    setSelectedSubVendor(null);
    setShowAddSubVendor(true);
  };

  const handleCancelAddSubVendor = () => {
    setShowAddSubVendor(false);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Apply click pannumpothu API call nadakkum
  const handleApplyFilter = () => {
    setCurrentPage(1);
    fetchSubVendors(filters); // Pass current filters to API
    setShowFilter(false);
  };

  // Initial Load
  useEffect(() => {
    if (userDetails.token && userDetails.orgId) {
      fetchSubVendors();
    }
  }, [userDetails.token, userDetails.orgId]);

  const handleClearFilter = () => {
    setFilters({
      subVendorType: "",
      subVendorCategory: "",
      status: "",
      location: "",
      sortBy: "",
    });
    setCurrentPage(1);
  };

  const handleRowClick = async (subVendor) => {
    if (!subVendor.subVendorId) {
      setSelectedSubVendor(subVendor);
      setShowAddSubVendor(true);
      return;
    }

    try {
      const response = await fetch(
        `${config.API_BASE_URL}${config.SUBVENDOR_DETAIL_ENDPOINT}${subVendor.subVendorId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch sub vendor details");
      }

      const fullData = await response.json();
      console.log("SubVendor detail response", fullData);
      const detail = fullData?.data || fullData;
      setSelectedSubVendor(detail);
      setShowAddSubVendor(true);
    } catch (err) {
      console.error("Error fetching subvendor details:", err);
      setError("Could not load sub vendor details.");
    }
  };

  if (showAddSubVendor) {
    return (
      <AddSubVendor
        onCancel={handleCancelAddSubVendor}
        selectedSubVendor={selectedSubVendor}
        fetchSubVendors={fetchSubVendors}
      />
    );
  }

  const filteredSubVendors = subVendors.filter((subVendor) => {
    const matchSearch = subVendor.subVendorName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchType = filters.subVendorType === "" ||
      subVendor.subVendorType === filters.subVendorType;

    const matchCategory = filters.subVendorCategory === "" ||
      subVendor.subVendorCategory === filters.subVendorCategory;

    const matchStatus = filters.status === "" ||
      subVendor.status === filters.status;

    const matchLocation = filters.location === "" ||
      subVendor.city === filters.location;

    return matchSearch && matchType && matchCategory && matchStatus && matchLocation;
  });

  // Sort the filtered results
  let sortedSubVendors = [...filteredSubVendors];
  if (filters.sortBy === "name-asc") {
    sortedSubVendors.sort((a, b) =>
      a.subVendorName.localeCompare(b.subVendorName)
    );
  } else if (filters.sortBy === "name-desc") {
    sortedSubVendors.sort((a, b) =>
      b.subVendorName.localeCompare(a.subVendorName)
    );
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSubVendors = sortedSubVendors.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(sortedSubVendors.length / itemsPerPage) || 1;
  const truncateText = (text, limit = 20) => {
    if (!text) return "-";
    return text.length > limit
      ? text.substring(0, limit) + "..."
      : text;
  };


  return (
    <div>
      <Header
        title="Sub Vendor List"
        subtitle="Sub Vendor Information"
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />

      <div className='table-container'>
        {error && <div style={{ color: "red", padding: "16px" }}>{error}</div>}
        <div className='table-controls'>
          <div className="search-wrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <IoSearchOutline
              style={{
                position: 'absolute',
                left: '15px',
                fontSize: '15px',
                color: '#999'
              }}
            />
            <input
              type='text'
              className='search-input'
              placeholder='Search'
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              /* Width and Padding setup */
              style={{
                paddingLeft: '40px',
                width: '145px',
                height: '15px',
              }}
            />
          </div>
          <div className='button-container'>
            <button className='add-client-btn' onClick={handleAddSubVendor}>
              <GrAddCircle />
              <span className='add-client-text'>Add Sub Vendor</span>
            </button>
            <button className='filter-btn' onClick={() => setShowFilter(true)}>
              <BsSliders />
              <span className='filter-btn-text'>Filter</span>
            </button>
          </div>
        </div>
        <table className='sub-vendor-table'>
          <thead>
            <tr>
              <th>Sub Vendor Name</th>
              <th>Sub Vendor Category</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Sub Vendor Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                  Loading sub vendor data...
                </td>
              </tr>
            ) : currentSubVendors.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  No sub vendors found
                </td>
              </tr>
            ) : (
              currentSubVendors.map((subVendor, index) => (
                <tr key={index} onClick={() => handleRowClick(subVendor)}>
                  <td title={subVendor.subVendorName}>
                    {truncateText(subVendor.subVendorName, 20)}
                  </td>
                  <td>{subVendor.subVendorCategory}</td>
                  <td>{subVendor.phoneNumber}</td>
                  <td>{subVendor.subVendorEmail}</td>
                  <td>{subVendor.subVendorType}</td>
                  <td>
                    <span
                      className={`status-badge ${subVendor.status === "Active"
                          ? "active"
                          : "inactive"
                        }`}
                    >
                      {subVendor.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className='table-footer'>
          <div className='record-count'>
            Showing {sortedSubVendors.length === 0 ? 0 : indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, sortedSubVendors.length)} of{" "}
            {sortedSubVendors.length} entries
          </div>

          <div className='pagination'>
            <button
              className='pagination-button'
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              &lt;
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={`pagination-button ${currentPage === i + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className='pagination-button'
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              &gt;
            </button>
          </div>
        </div>
      </div>

      {/* Filter Modal */}
      {showFilter && (
        <div className='filter-modal-overlay' onClick={() => setShowFilter(false)}>
          <div className='filter-modal' onClick={(e) => e.stopPropagation()}>
            <h3 className='filter-title'>Filter</h3>

            <div className='filter-group'>
              <label>Sub Vendor Type</label>
              <select
                name='subVendorType'
                value={filters.subVendorType}
                onChange={handleFilterChange}
                className='filter-dropdown'
              >
                <option value=''></option>
                {vendorTypes.length > 0 ? (
                  vendorTypes.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.values}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </select>

            </div>

            <div className='filter-group'>
              <label>Sub Vendor Category</label>
              <select
                name='subVendorCategory'
                value={filters.subVendorCategory}
                onChange={handleFilterChange}
                className='filter-dropdown'
              >
                <option value=''></option>
                {vendorCategories.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.values}
                  </option>

                ))}
              </select>
            </div>

            <div className='filter-group'>
              <label>Status</label>
              <select
                name='status'
                value={filters.status}
                onChange={handleFilterChange}
                className='filter-dropdown'
              >
                <option value=''></option>
                <option value='Active'>Active</option>
                <option value='Inactive'>Inactive</option>
              </select>
            </div>

            <div className='filter-group'>
              <label>Location</label>
              <select
                name='location'
                value={filters.location}
                onChange={handleFilterChange}
                className='filter-dropdown'
              >
                <option value=''></option>
                {[...new Set(subVendors.map((v) => v.city))].filter(Boolean).map(
                  (city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className='filter-group'>
              <label>Sort By</label>
              <select
                name='sortBy'
                value={filters.sortBy}
                onChange={handleFilterChange}
                className='filter-dropdown'
              >
                <option value=''></option>
                <option value='name-asc'>Name (A-Z)</option>
                <option value='name-desc'>Name (Z-A)</option>
              </select>
            </div>

            <div className='filter-buttons'>
              <button className='clear-btn' onClick={handleClearFilter}>
                Clear
              </button>
              <button className='apply-btn' onClick={handleApplyFilter}>
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubVendor;
